import { render } from "./PasswordReset.vue?vue&type=template&id=4ea824d0&ts=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__